export default "__VITE_ASSET__NMoCSnhu__"